import { ACTION_GET_SCREEN_SUCCESS } from '../actions/actionTypes';

const initialState = { };

export default function screenReducer(state = initialState, action) {
    
    switch (action.type) {
    
        case ACTION_GET_SCREEN_SUCCESS:
            return action.screen.Data;
        default:
            return state;

    }

}


/** WEBPACK FOOTER **
 ** ./src/reducers/screenReducer.js
 **/